/**
 * Alıcı geçmişi — TCKN/VKN girilince bu kişiye daha önce kesilen son faturadan
 * vergi dairesi / adres / il-ilçe (05.10.2026).
 *
 * Kolaysoft'un mükellef sorgusu (QueryUsers) yalnız VKN, unvan ve etiket
 * döndürüyor; vergi dairesi ve adres veren servisi yok (EDM veriyordu). Arşivde
 * e-Fatura alıcılarının ~%93'ünde vergi dairesi kayıtlı; fatura kesildikçe
 * arşiv anında güncellendiği için bilgi bir sonraki faturada kendiliğinden gelir.
 */

import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const dolu = (v) => {
  const t = String(v ?? '').trim();
  return t && t !== '-' ? t : '';
};

/** Saf seçim (test edilebilir): en yeni tarihli, bilgisi olan fatura. */
export const pickRecipientDetails = (docs = []) => {
  const sirali = [...docs].sort((a, b) => String(b.invoiceDate || '').localeCompare(String(a.invoiceDate || '')));
  const sonuc = { taxOffice: '', street: '', city: '', district: '', kaynak: null };
  for (const d of sirali) {
    const c = d?.ubl?.customer || {};
    if (!sonuc.taxOffice && dolu(c.taxOffice)) {
      sonuc.taxOffice = dolu(c.taxOffice);
      sonuc.kaynak = sonuc.kaynak || d;
    }
    // Adres il/ilçe ile birlikte alınır: aynı faturadan, tutarlı olsun
    if (!sonuc.street && dolu(c.street)) {
      sonuc.street = dolu(c.street);
      sonuc.city = dolu(c.city);
      sonuc.district = dolu(c.district);
      sonuc.kaynak = sonuc.kaynak || d;
    }
    if (sonuc.taxOffice && sonuc.street) break;
  }
  return sonuc;
};

export async function fetchRecipientDetails(taxId) {
  const id = String(taxId || '').replace(/\D/g, '');
  if ((id.length !== 10 && id.length !== 11) || id === '11111111111') return null;
  const snap = await getDocs(query(collection(db, 'kolaysoftFaturalari'), where('recipientId', '==', id), limit(50)));
  if (snap.empty) return null;
  const sonuc = pickRecipientDetails(snap.docs.map((d) => d.data()));
  return sonuc.taxOffice || sonuc.street ? sonuc : null;
}
